var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayinline = function SvgPlayinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.9182 7.34472C13.4227 7.63596 13.4227 8.36404 12.9182 8.65528L3.83843 13.8975C3.33399 14.1887 2.70345 13.8247 2.70345 13.2422L2.70345 2.75778C2.70345 2.17531 3.33399 1.81127 3.83843 2.1025L12.9182 7.34472Z"
  })));
};
export default SvgPlayinline;